import styled from 'styled-components';

export const GroupChip = styled.ul`
  flex-wrap: wrap;
`;
